/* eslint-disable import/prefer-default-export */

export const isMobileAndTablet = () => {
    if (typeof window === `undefined`) return false
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
    let hasTouchScreen = false
    if ('maxTouchPoints' in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0
    } else if ('msMaxTouchPoints' in navigator) {
        hasTouchScreen = navigator.msMaxTouchPoints > 0
    } else {
        const mQ = window.matchMedia?.('(pointer:coarse)')
        if (mQ?.media === '(pointer:coarse)') {
            hasTouchScreen = !!mQ.matches
        } else if ('orientation' in window) {
            hasTouchScreen = true // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            const UA = navigator.userAgent
            hasTouchScreen =
                /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
        }
    }
    return hasTouchScreen
}

export const getUserAgent = () => {
    if (typeof window === `undefined`) return ''
    const regex = /chrome|firefox/i
    let ua = 'unsupported'
    const {userAgent} = window.navigator
    if (userAgent.match(regex)) {
        ;[ua] = userAgent.match(regex)
    }
    if (ua === 'Chrome' && userAgent.match(/edge?\//i)) {
        ua = 'Edge'
    }
    return ua.toLowerCase()
}

export const isChrome = () => {
    return getUserAgent() === 'chrome'
}

export const isFirefox = () => {
    return getUserAgent() === 'firefox'
}

export const isEdge = () => {
    return getUserAgent() === 'edge'
}

export const isIOS = () => {
    if (typeof window === `undefined`) return false
    const regex = /ipad|iphone/i
    const {userAgent} = window.navigator
    return userAgent.match(regex) !== null
}

export const isMacintosh = () => {
    if (typeof window === `undefined`) return false
    const regex = /macintosh/i
    const {userAgent} = window.navigator
    return userAgent.match(regex) !== null
}

export const isIpad = () => {
    if (typeof window === `undefined`) return false
    return isMobileAndTablet() && isMacintosh()
}

export const isAndroid = () => {
    if (typeof window === `undefined`) return false
    const regex = /android/i
    const {userAgent} = window.navigator
    return userAgent.match(regex) !== null
}

export const isUnsupported = () => {
    return getUserAgent() === 'unsupported'
}

export const isMac = () => {
    if (typeof window === `undefined`) return false
    const regex = /macintosh/i
    const {userAgent} = window.navigator
    return userAgent.match(regex) !== null
}

export const isWindows = () => {
    if (typeof window === `undefined`) return false
    const regex = /windows/i
    const {userAgent} = window.navigator
    return userAgent.match(regex) !== null
}

export const isUnsupportedOS = () => {
    if (typeof window === `undefined`) return false
    if (isMobileAndTablet()) return true
    return !isMac() && !isWindows()
}

export const isUnsupportedAppOS = () => {
    if (typeof window === `undefined`) return false
    if (isIOS() || isIpad() || isAndroid()) return false
    return true
}

export const getAppUserAgent = () => {
    if (typeof window === `undefined`) return ''
    if (isIOS() || isIpad()) return 'ios'
    if (isAndroid()) return 'android'
    return 'unsupported'
}
